import { createContext } from 'react'

export type CoverageAuditReasonContextType = {
  reason: string
  setReason: (reason: string) => void
  openReasonDropdown?: () => void
  showReasonWarning?: boolean
}

const CoverageAuditReasonContext = createContext<CoverageAuditReasonContextType>({
  reason: 'unknown',
  setReason: () => {},
  openReasonDropdown: () => {},
  showReasonWarning: false,
})

export default CoverageAuditReasonContext
